import script from "./OrderFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderFooter.vue?vue&type=script&setup=true&lang=ts"

import "./OrderFooter.vue?vue&type=style&index=0&id=ab069f84&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab069f84"]])

export default __exports__